export default "__VITE_ASSET__4cf8b867__"